module.exports = __webpack_public_path__ + "static/media/tebo.7d8302c5.jpg";